<template>
	<core-layout-headline-with-tabs :tabs="tabs">{{ $t("users") }}</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			// If devFlag for advanced user management
			if (this.$store.state.settings.devFlags.hasAdvancedUserManagement)
				return [
					{
						name: this.$t("manage_users"),
						to: { name: "UsersManagement" }
					},
					{
						name: this.$t("permission_groups"),
						to: `/${this.$route.params.tenantId}/users/permission-groups`
					}
				]
			else
				return [
					{
						name: this.$t("manage_users"),
						to: `/${this.$route.params.tenantId}/users/manage-users`
					},
					{
						name: this.$t("permission_groups"),
						to: `/${this.$route.params.tenantId}/users/permission-groups`
					}
				]
		}
	}
}
</script>
